/**
 * Limpia un RUT de puntos, guiones y espacios.
 * @param {string} rut
 * @returns {string} RUT limpio en mayúsculas.
 */
export const cleanRut = (rut = '') =>
  String(rut).replace(/[.\s-]/g, '').toUpperCase();

/**
 * Normaliza un RUT chileno al formato 12345678-9.
 * No valida el dígito verificador.
 * @param {string} rut
 * @returns {string} RUT normalizado o cadena vacía.
 */
export const normalizeRut = (rut = '') => {
  const cleaned = cleanRut(rut);
  if (!/^[0-9]+[0-9K]$/.test(cleaned)) return '';
  const body = cleaned.slice(0, -1);
  const dv = cleaned.slice(-1);
  return `${body}-${dv}`;
};

/**
 * Valida un RUT chileno.
 * @param {string} rut El RUT a validar.
 * @returns {boolean} `true` si el RUT es válido, `false` en caso contrario.
 */
export const validateRut = (rut) => {
  const normalized = normalizeRut(rut);
  if (!/^[0-9]+-[0-9kK]{1}$/.test(normalized)) {
    return false;
  }
  const [numero, dv] = normalized.split('-');
  let suma = 0;
  let multiplo = 2;

  for (let i = numero.length - 1; i >= 0; i--) {
    suma += parseInt(numero.charAt(i), 10) * multiplo;
    multiplo = multiplo === 7 ? 2 : multiplo + 1;
  }

  const dvEsperado = 11 - (suma % 11);
  const dvFinal = dvEsperado === 11 ? '0' : dvEsperado === 10 ? 'K' : dvEsperado.toString();

  return dvFinal.toUpperCase() === dv.toUpperCase();
};
